import { useAuth } from "@/contexts";
import { Navigate } from "react-router-dom";

export const AuthGuard = ({ children }: { children: JSX.Element }) => {
  const auth = useAuth();

  const isAllowed = auth.isLoggedIn && auth.user?.permissions?.length;

  return isAllowed ? children : <Navigate replace to="/login" />;
};
